/**
 * The predictive search modal is native Horizon markup we don't control directly,
 * and it renders prices using Shopify's default money format (e.g. "Tk 6,000.00").
 * This watches the search results for changes and rewrites price text to match
 * our site-wide "6,000 Tk" format (currency after the number, no trailing .00).
 */
(function () {
  function reformatPriceText(el) {
    if (!el || el.dataset.priceFormatted === 'true') return;
    const raw = el.textContent.trim();
    // Extract the numeric portion (with commas/decimals) from strings like "Tk 22,000.00"
    const match = raw.match(/([\d,]+(?:\.\d+)?)/);
    if (!match) return;

    let numeric = match[1].replace(/,/g, '');
    const amount = parseFloat(numeric);
    if (isNaN(amount)) return;

    const hasCents = Math.abs(amount % 1) > 0.001;
    const formatted = amount.toLocaleString('en-US', {
      minimumFractionDigits: hasCents ? 2 : 0,
      maximumFractionDigits: 2
    });

    el.textContent = `${formatted} Tk`;
    el.dataset.priceFormatted = 'true';
  }

  function scanAndFormat(root) {
    if (!root) return;
    root.querySelectorAll('.predictive-search-results__card--product .price, .predictive-search-results__card--product .compare-at-price').forEach(reformatPriceText);
  }

  document.addEventListener('DOMContentLoaded', function () {
    const searchModal = document.querySelector('[id*="search-modal"], .predictive-search, dialog');
    const target = document.body;

    // Predictive search results render dynamically as the user types, so watch for changes.
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) {
            scanAndFormat(node);
          }
        });
      });
    });

    observer.observe(target, { childList: true, subtree: true });

    // Also run once on load in case results are already present
    scanAndFormat(document);
  });
})();
